import setPromiseState from '../../utils/promiseState';

export default {
  tourList: [],
  tourForEdit: {
    tourDates: []
  },
  isShowPopup: false,
  error: {},
  promise: {
    createTour: setPromiseState(),
    getTourList: setPromiseState(),
    getTourById: setPromiseState(),
    deletePhotoTour: setPromiseState(),
    addPhotoTour: setPromiseState(),
    uploadVideo: setPromiseState(),
  },
}


// WEBPACK FOOTER //
// ./src/app/containers/Vendor/InitState.js